/**
 * Vrai pour une réponse HTTP que répéter la même requête ne changera pas :
 * session expirée (401), accès refusé (403), ressource hors de portée (404).
 * Le retry global de TanStack Query et les polls s'arrêtent sur ces statuts.
 */
export function isTerminalHttpError(error: unknown): boolean {
  if (!(error instanceof Error) || !('statusCode' in error)) return false;
  return error.statusCode === 401 || error.statusCode === 403 || error.statusCode === 404;
}
